module.exports = __webpack_public_path__ + "static/media/home_map.50fded67.png";